import React from 'react';
import classes from './spinner.css';

const Spinner = () => {
	return <div className={classes.loader}>Loading...</div>;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js